var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTalkShows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Election-Debate-5--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Election Debate 5 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 19H1a1 1 0 0 0 0 2h0.15l0.36 2.18a1 1 0 0 0 1 0.84h6a1 1 0 0 0 1 -0.84L9.85 21H10a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19h-9a1 1 0 0 0 0 2h0.15l0.36 2.18a1 1 0 0 0 1 0.84h6a1 1 0 0 0 1 -0.84l0.34 -2.18H23a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14.37a2.2 2.2 0 0 0 1.35 -3.93l-0.07 0 -0.07 -0.05 -0.07 -0.05a1.87 1.87 0 0 0 -0.32 -0.15l-0.06 0H5.23l-0.1 0L5 10a2.2 2.2 0 0 0 0.5 4.34Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33 18h6.34a0.25 0.25 0 0 0 0.2 -0.1 0.27 0.27 0 0 0 0 -0.23 3.59 3.59 0 0 0 -6.82 0 0.27 0.27 0 0 0 0 0.23 0.28 0.28 0 0 0 0.28 0.1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 10 -0.12 0 -0.11 0h-0.9l-0.06 0 -0.06 0A2.2 2.2 0 1 0 19 10Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 10.5h1l3.36 2.88a0.47 0.47 0 0 0 0.32 0.12 0.54 0.54 0 0 0 0.21 -0.05A0.48 0.48 0 0 0 14 13v-2.5h1.2a3.69 3.69 0 0 1 3.3 -2 4.07 4.07 0 0 1 0.5 0V1.69A1.69 1.69 0 0 0 17.31 0H6.69A1.69 1.69 0 0 0 5 1.69v6.82a4.07 4.07 0 0 1 0.5 0 3.71 3.71 0 0 1 3.3 1.99Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.09 17.64a0.27 0.27 0 0 0 0 0.23 0.28 0.28 0 0 0 0.21 0.1h6.34a0.25 0.25 0 0 0 0.2 -0.1 0.27 0.27 0 0 0 0 -0.23 3.59 3.59 0 0 0 -6.82 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTalkShows);
export default ForwardRef;